// Message Repository - OOP Pattern (Repository Pattern)
import { IApiClient } from '../interfaces/IApiClient';
import { IMessage, IMessageDetail, IQueueJob } from '../interfaces/IMessage';
import { SendSingleMessageDto, SendGroupMessageDto, SendBulkMessageDto, SendGroupsQueuedDto } from '../dto/MessageDto';

export class MessageRepository {
  constructor(private apiClient: IApiClient) {}

  async sendSingle(dto: SendSingleMessageDto): Promise<IMessage> {
    return this.apiClient.post<IMessage>('/messages/send-single', {
      to: dto.to,
      body: dto.body,
      type: dto.type,
      sidTemplate: dto.sidTemplate,
    });
  }

  async sendToGroup(dto: SendGroupMessageDto): Promise<IMessage> {
    return this.apiClient.post<IMessage>('/messages/send-group', {
      groupId: dto.groupId,
      body: dto.body,
      type: dto.type,
      sidTemplate: dto.sidTemplate,
    });
  }

  async sendGroupsQueued(dto: SendGroupsQueuedDto): Promise<IQueueJob> {
    return this.apiClient.post<IQueueJob>('/messages/send-groups-queued', {
      groupIds: dto.groupIds,
      body: dto.body,
      type: dto.type,
      sidTemplate: dto.sidTemplate,
      selectedDamIds: dto.selectedDamIds,
    });
  }

  async sendBulk(dto: SendBulkMessageDto): Promise<IMessage> {
    return this.apiClient.post<IMessage>('/messages/send-bulk', {
      recipients: dto.recipients,
      body: dto.body,
      type: dto.type,
      sidTemplate: dto.sidTemplate,
    });
  }

  async getAll(): Promise<IMessage[]> {
    return this.apiClient.get<IMessage[]>('/messages');
  }

  async getById(id: string): Promise<IMessageDetail> {
    return this.apiClient.get<IMessageDetail>(`/messages/${id}`);
  }

  async getQueueJob(jobId: string): Promise<IQueueJob> {
    return this.apiClient.get<IQueueJob>(`/queue/jobs/${jobId}`, {
      headers: {
        'x-skip-cache': true,
      },
    });
  }
}
